var MassUpateController = (function () {
    function MassUpateController($scope, $state, env, Dialog, socket, $mdDialog) {
        this.$scope = $scope;
        this.$state = $state;
        this.env = env;
        this.Dialog = Dialog;
        this.socket = socket;
        this.$mdDialog = $mdDialog;
        this.bpoiFile = null;
        this.scopePrefix = "admin.massUpdate";
        this.scopeBPOIUpload = this.scopePrefix + ".bpoi.upload";
        this.scopePermittedUsers = this.scopePrefix + ".bpoi.permissions";
        this.scopeUpdateProgress = this.scopePrefix + ".progress";
        this.permittedUsers = ["evgeny.sorokin@ibm.com"];
        this.inProgress = false;
    }
    MassUpateController.prototype.$onInit = function () {
        var _this = this;
        this.socket.forward(this.scopeBPOIUpload, this.$scope);
        this.$scope.$on("socket:" + this.scopeBPOIUpload, function (event, data) {
            console.log(data.msg);
            _this.$mdDialog.show(_this.$mdDialog
                .alert()
                .parent(angular.element(document.body))
                .clickOutsideToClose(true)
                .title("Alert!")
                .textContent(data.msg)
                .ok("Got it!"));
            if (data.status === 'success') {
                _this.bpoiFile = null;
            }
        });
        this.socket.forward(this.scopeUpdateProgress, this.$scope);
        this.$scope.$on("socket:" + this.scopeUpdateProgress, function (event, data) {
            _this.inProgress = data.inProgress;
        });
        this.socket.forward(this.scopePermittedUsers, this.$scope);
        this.$scope.$on("socket:" + this.scopePermittedUsers, function (event, data) {
            if (!data.permitted) {
                _this.$mdDialog.show(_this.$mdDialog
                    .alert()
                    .parent(angular.element(document.body))
                    .clickOutsideToClose(true)
                    .title("Alert!")
                    .textContent("You're not allowed to view this page")
                    .ariaLabel("not allowed alert")
                    .ok("Got it!"));
                _this.$state.go("admin.main");
            }
        });
        this.checkPermission();
        this.checkUpdateStatus();
    };
    MassUpateController.prototype.checkPermission = function () {
        this.socket.emit("module", {
            module: {
                application: "dmt",
                data: {},
                function: "getUserPermission",
                scopeBack: this.scopePermittedUsers,
                script: "admin/mass-update/mass-update",
                email: this.env.user.email,
                token: this.env.user.token
            }
        });
    };
    MassUpateController.prototype.isSubmitDisabled = function () {
        return this.inProgress || !this.bpoiFile;
    };
    MassUpateController.prototype.checkUpdateStatus = function () {
        this.socket.emit("module", {
            module: {
                application: "dmt",
                data: {},
                function: "checkMassUpdateProgress",
                scopeBack: this.scopeUpdateProgress,
                script: "admin/mass-update/mass-update",
                email: this.env.user.email,
                token: this.env.user.token
            }
        });
    };
    MassUpateController.prototype.selectBPOIFile = function (event, files) {
        this.bpoiFile = files[0];
    };
    MassUpateController.prototype.onBPOISubmit = function (event) {
        if (this.bpoiFile) {
            this.uploadBPOIFile(this.bpoiFile);
            this.inProgress = true;
            this.checkUpdateStatus();
        }
    };
    MassUpateController.prototype.uploadBPOIFile = function (file) {
        this.socket.emit("module", {
            module: {
                application: "dmt",
                data: {
                    file: file,
                    fileType: file.type
                },
                function: "uploadBPOIFile",
                scopeBack: this.scopeBPOIUpload,
                script: "admin/mass-update/mass-update",
                email: this.env.user.email,
                token: this.env.user.token
            }
        });
    };
    MassUpateController.$inject = [
        "$scope",
        "$state",
        "env",
        "Dialog",
        "socket",
        "$mdDialog"
    ];
    return MassUpateController;
}());
var MassUpdateComponent = (function () {
    function MassUpdateComponent() {
        this.templateUrl = "mass-update.html";
        this.controllerAs = "vm";
        this.controller = MassUpateController;
    }
    return MassUpdateComponent;
}());
angular
    .module("application")
    .component("massUpdateSection", new MassUpdateComponent());

//# sourceMappingURL=massupdate-view.component.js.map
